// Vue 2 compatible useWindowResize - returns a simple getter function instead of a ref
const useWindowResize = () => {
  // Return an object that behaves like a reactive value compatible with Vue 2
  // Components using this hook should call windowWidth() to get the value
  let _width = window.innerWidth;
  
  const update = () => {
    _width = window.innerWidth;
  };
  
  window.addEventListener('resize', update);
  
  // Return a plain object mimicking the ref behavior for Vue 2 compatibility
  return {
    get value() { return _width; },
  };
};

export default useWindowResize;
